import React from "react";

const TravelSummary = () => {
  return (
    <div className="dashboard-card">
      <div className="card-header">
        <h3 className="card-title">Travel Summary</h3>
      </div>

      <div className="card-body">
        <p>Pending Trips : 7</p>
        <p>Approved Trips : 38</p>
        <p>Settled Trips : 31</p>
      </div>
    </div>
  );
};

export default TravelSummary;